import { InputData } from "../input/InputData";
import { PHPAdress, PHPAdresses } from "../PHPAdress";
import { PHPRequest } from "../PHPRequest";
import { PHPResponse } from "../PHPResponse";
import { CartEntryListResponse } from "./CartEntryListResponse";
import { CartItemInput } from "./CartItemInput";


export class AddItemToCartRequest extends PHPRequest<PHPAdress,CartItemInput,CartEntryListResponse>
{
  static readonly adress = PHPAdresses.CART_ADD_ITEM;

  constructor()
  {
    super( AddItemToCartRequest.adress );
  }
}